import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, timer, of, concat } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { S3_STORAGE_BASE_URL } from './s3-storage-base-url.injection-token';

interface PresignRecordingUrlResponse {
  url: string;
}

@Injectable({ providedIn: 'root' })
export class S3StorageService {
  private readonly presignUrl: string;

  constructor(private http: HttpClient, @Inject(S3_STORAGE_BASE_URL) baseUrl: string) {
    this.presignUrl = baseUrl + '/presign-recording-url';
  }

  resolve(url: string): Observable<string> {
    return this.fetchPresignedUrl(url).pipe(
      switchMap(presignedUrl => {
        const refreshMs = this.getRefreshMs(presignedUrl);
        return concat(of(presignedUrl), timer(refreshMs, refreshMs).pipe(switchMap(() => this.fetchPresignedUrl(url))));
      }),
    );
  }

  private fetchPresignedUrl(url: string): Observable<string> {
    return this.http.post<PresignRecordingUrlResponse>(this.presignUrl, { recording_url: url }).pipe(map(response => response.url));
  }

  private getRefreshMs(presignedUrl: string): number {
    const params = new URL(presignedUrl).searchParams;
    const expiresSeconds = Number(params.get('X-Amz-Expires'));
    return expiresSeconds * 0.8 * 1000;
  }
}
